const guides = {
  Guide1: require('../../assets/images/Guide 1.png'),
  Guide2: require('../../assets/images/Guide 2.png'),
  Guide31: require('../../assets/images/Guide 3.1.png'),
  Guide32: require('../../assets/images/Guide 3.2.png'),
  Guide41: require('../../assets/images/Guide 4.1.png'),
  Guide42: require('../../assets/images/Guide 4.2.png'),
  Guide43: require('../../assets/images/Guide 4.3.png'),
  CDPGuide1: require('../../assets/images/CDP-Guide1.png'),
  CDPGuide2: require('../../assets/images/CDP-Guide2.png'),
  CDPGuide3: require('../../assets/images/CDP-Guide3.png'),
}

export default guides
